import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import {
  BenchmarkDataPrimaryLookupService,
  BmarkFixingData,
  BmarkFixingType,
  ActiveUser,
} from "shared/cubiq-services";
import { BmarkClientOrdersBlotterMode } from "../../shared/cubiq-services/model/benchmarks/enums/BmarkClientOrdersBlotterMode.enum";
import { BmarkSpotRiskBlotterComponent } from "./blotters/spot-risk/bmark-spot-risk-blotter.component";
import { Subscription } from "rxjs";
import { BmarkFixingsManagerService } from "./services/bmark-fixings-manager.service";
import { AmountViewType } from "../bfx-menus/bfx-blotter-settings-menu.component";
import { ChildBlotterComponent } from "./models/bmark-sub-blotter.interface";
import { FilterConfiguration } from "../bfx-blotter-filter/FilterConfiguration";
import { SETTINGS_PROPERTY_AMOUNTVIEWTYPE } from "app/bfx-user-settings/bfx-bmark-summary-settings-preferences.component";

const DEFAULT_AMOUNTVIEW_TYPE = AmountViewType.NOTIONAL;

@Component({
  selector: "bmark-summary-spot-risk",
  templateUrl: "./html/bmark-summary-spot-risk.html",
  standalone: false,
})
export class BmarkSummarySpotRiskContainerComponent
  implements OnInit, ChildBlotterComponent, OnChanges, OnDestroy
{
  @Input() activeView: BmarkClientOrdersBlotterMode;

  /**********************************************************************/
  /* DATA */
  public orderIds: string = "";
  public tableView: string = "";
  public fixing: string = "";
  public type: string = "";

  private displayFixingSubscription: Subscription;

  @ViewChild(BmarkSpotRiskBlotterComponent, { static: true })
  bmarkSpotRiskBlotter: BmarkSpotRiskBlotterComponent;
  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(private bmarkManager: BmarkFixingsManagerService) {}

  /**********************************************************************/
  /* INITIALIZE */
  ngOnInit() {
    this.initializeManager();
  }

  protected initializeManager(): void {
    this.displayFixingSubscription = this.bmarkManager.displayFixing$.subscribe(
      (fixingData: BmarkFixingData) => {
        if (fixingData instanceof BmarkFixingData) {
          this.type = `${BmarkFixingType[fixingData.type]}`;
          this.fixing = `${fixingData.displayTime} ${fixingData.code} (${fixingData.displayDate})`;
          this.orderIds = fixingData.hasClientOrders()
            ? fixingData.getClientOrderIds().toString()
            : "Unknown";
        } else {
          this.type = "";
          this.fixing = "";
          this.orderIds = "";
        }
      },
    );
  }

  /**********************************************************************/
  /* CHANGES */
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      switch (propName) {
        case "activeView":
          this.tableView = BmarkClientOrdersBlotterMode[this.activeView];
          this.bmarkSpotRiskBlotter.setBmarkViewType(this.activeView);
          break;
      }
    }
  }
  /**********************************************************************/
  /* Destroy */
  ngOnDestroy() {
    if (this.displayFixingSubscription) {
      this.displayFixingSubscription.unsubscribe();
      this.displayFixingSubscription = null;
    }
  }

  setAmountViewType(type: AmountViewType) {
    this.bmarkSpotRiskBlotter.setAmountViewType(type);
  }

  getAmountViewType(): AmountViewType {
    return this.bmarkSpotRiskBlotter.getAmountViewType();
  }

  /**********************************************************************/
  /* BLOTTER - PROFILE */

  public getRiskConfiguration(): any {
    return this.bmarkSpotRiskBlotter.getComponentConfiguration();
  }

  public getBlotterId() {
    return this.bmarkSpotRiskBlotter.getBlotterId();
  }

  public getBlotterInstance() {
    return this.bmarkSpotRiskBlotter.getBlotterInstance();
  }

  filterSelectionChanged(filterConfiguration: FilterConfiguration) {
    // filter changes are handlled with events into the data service
  }

  getFilterConfiguration(): void {
    return null;
  }

  setBlotterFilterComponent(blotterFilter: any): void {
    // Spot risk does not support blotter filtering - only through service events
  }

  refreshSelectionCells(): void {
    this.bmarkSpotRiskBlotter.refreshSelectionCells();
  }
  hasCellRenderedSelection(): boolean {
    return this.bmarkSpotRiskBlotter.hasCellRenderedSelection();
  }

  public getProfileSettingKey(): string {
    return this.bmarkSpotRiskBlotter.getProfileSettingKey();
  }

  public initializeAmountView(userData: ActiveUser): AmountViewType {
    let ret: AmountViewType = DEFAULT_AMOUNTVIEW_TYPE;
    let jsonString: string = userData.profileSettings.get(this.getProfileSettingKey());
    let spotRiskSettings = jsonString != null ? JSON.parse(jsonString) : null;
    if (spotRiskSettings && spotRiskSettings.hasOwnProperty(SETTINGS_PROPERTY_AMOUNTVIEWTYPE)) {
      ret = spotRiskSettings[SETTINGS_PROPERTY_AMOUNTVIEWTYPE];
      if (null == ret) {
        ret = DEFAULT_AMOUNTVIEW_TYPE;
      }

      this.setAmountViewType(ret);
    }

    return ret;
  }
}
